import { IParameterizable } from './page-service/parameterizable.model';
import { IQueryParams } from './page-service/query-params.model';

export class Search implements IParameterizable {
    query: string;

    constructor(query: string) {
        this.query = query;
    }

    generateParams(): IQueryParams {
        return {
            queryString: 'search',
            params: this.query ? [{ value: this.query }] : [],
        };
    }
}
